// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3MwUz","filesListContainer":"PosDisputesFiles_filesListContainer__oR1Nq","filesButton":"PosDisputesFiles_filesButton__2j1-s"};